import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-trial-component',
    templateUrl: 'trial.component.html',
    styleUrls: ['trial-us.component.scss'],
    standalone: false
})

export class TrialComponent {
  cdnPath = environment.cdnPath;
}
